<template>
    <div>
      <Pos_invoices_close_summary/>
    </div>
  </template>
  
  <script>
  import Pos_invoices_close_summary from "@/components/adminArin/pos_system/pos/Pos_invoices_close_summary";
  export default {
    name: "PosInvoicesCloseSummary",
    components: {
      Pos_invoices_close_summary
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  